import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  ChangeDetectorRef,
  OnDestroy,
  ViewChild,
  HostListener,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GroupContextService, hd, IGroupModel, TicketService } from '@nx-fe/services';
import { createGroupStateObserver } from 'app/utils/group-display.helper';
import { from, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface TicketCreateDialogData {
  icon: string;
  title: string;
  groups: hd.IGroupModel[];
}

@Component({
  selector: 'sa-ticket-create-dialog',
  templateUrl: './ticket-create-dialog.component.html',
  styleUrls: ['./ticket-create-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TicketCreateDialogComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  public isConfirmed = false;
  public groups: IGroupModel[] = [];
  public selectedGroupId: number;
  public groupIdToPass: number;
  public opened = false;
  hideDescriptionTitle: boolean = true;
  selectedGroupName: string = '';

  groupSubscription: Subscription;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<TicketCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TicketCreateDialogData,
    private groupContext: GroupContextService,
    private ticketService: TicketService
  ) {
    this.setupGroups();
    this.groupContext.refreshGroups();
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setupGroups = () => {
    const groups = this.groupContext.allowedGroupsObservable;
    const ticketConfig = from(this.ticketService.getTicketUserConfiguration());

    if (this.groupSubscription !== undefined) {
      this.groupSubscription.unsubscribe();
    }

    this.groupSubscription = createGroupStateObserver(groups, ticketConfig)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(result => {
        this.groups = result.groups;
        if (this.selectedGroupId === undefined || this.selectedGroupId === null) {
          const defaultGroup = result.groups.find(group => group.groupId === 1);
          this.selectedGroupId = defaultGroup ? defaultGroup.groupId : this.groups[0]?.groupId;
        }
        this.groupIdToPass = this.selectedGroupId;
        setTimeout(() => {
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        });
      });
  };

  public onGroupIdChange(event: any): void {
    this.selectedGroupId = event;
    this.groupIdToPass = event;
  }

  getSelectedGroupName(): string {
    const selectedGroup = this.groups.find(group => group.groupId === this.selectedGroupId);
    return selectedGroup ? selectedGroup.groupName : '';
  }

  public cancel() {
    this.dialogRef.close(undefined);
  }

  public confirm() {
    this.dialogRef.close(this.groupIdToPass);
  }
}
